import Cookies from 'js-cookie'
import * as Sentry from '@sentry/browser'

import instance from 'lmcv/utils/axios'

export function ConfigureInterceptor () {
  instance.interceptors.request.use(
    config => {
      const TOKEN = Cookies.get('api_token')

      if (TOKEN) {
        config.headers.Authorization = `Bearer ${TOKEN}`
      }

      return config
    },
    error => {
      Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    response => response,
    error => {
      if (window.env && window.env.sentry.enabled === true) {
        Sentry.captureException({
          message: error,
          config
        })
      }

      return Promise.reject(error)
    }
  )
}
